module.exports = __webpack_public_path__ + "img/link.a4c33c0b.svg";